import { DebugJson, DebugKv, DebugSection } from '../DebugSection';
import { useTestMode } from '../hooks/useTestMode';

export interface TestModeSectionProps { searchTerm?: string }

export function TestModeSection({ searchTerm }: TestModeSectionProps): JSX.Element {
  const tm = useTestMode();
  const extra = (typeof window !== 'undefined' && window.__PCB_DEBUG_EXTRA__) || {};
  const tmExtra = (extra['testMode'] as Record<string, unknown> | undefined) ?? {};

  const rows = [
    { k: 'enabled', v: tm.enabled },
    { k: 'source', v: tm.source },
    { k: 'killList.total', v: tmExtra['killListTotal'] },
    { k: 'killList.pending', v: tmExtra['killListPending'] },
    { k: 'killList.killed', v: tmExtra['killListKilled'] },
    { k: 'currentCart.gateAllowed', v: tmExtra['gateAllowed'] },
    { k: 'currentCart.gateReason', v: tmExtra['gateReason'] },
  ];

  return (
    <DebugSection id="testmode" title="8. Test Mode" searchTerm={searchTerm}>
      <DebugKv rows={rows} searchTerm={searchTerm} />
      {Object.keys(tmExtra).length > 0 && (
        <details className="pcb-debug-details">
          <summary>extra (module-supplied)</summary>
          <DebugJson value={tmExtra} searchTerm={searchTerm} />
        </details>
      )}
      <div className="pcb-debug-note">
        Test Mode write-side admin lands in a future sprint; today this hook only
        reads from <code>config.systemSettings.testModeEnabled</code>.
      </div>
    </DebugSection>
  );
}
